import { useState } from "react";

import arrowSchedule from "@/assets/images/user/landing/arrow-schedule.svg";
import award from "@/assets/images/user/landing/award.svg";
import awardMobile from "@/assets/images/user/landing/award-mobile.svg";
import background from "@/assets/images/user/landing/background.png";
import bgBottom from "@/assets/images/user/landing/bg-bottom.png";
import bgBottomMobile from "@/assets/images/user/landing/bg-bottom-mobile.png";
import bgBottomTablet from "@/assets/images/user/landing/bg-bottom-tablet.png";
import bgTop from "@/assets/images/user/landing/bg-top.png";
import bgTopMobile from "@/assets/images/user/landing/bg-top-mobile.png";
import bgTopTablet from "@/assets/images/user/landing/bg-top-tablet.png";
import btnArrowPurple from "@/assets/images/user/landing/btn-arrow-purple.svg";
import btnArrowWhite from "@/assets/images/user/landing/btn-arrow-white.svg";
import btnBg1 from "@/assets/images/user/landing/btn-bg-1.svg";
import btnBgOn1 from "@/assets/images/user/landing/btn-bg-1-on.svg";
import btnBg2 from "@/assets/images/user/landing/btn-bg-2.svg";
import btnBgOn2 from "@/assets/images/user/landing/btn-bg-2-on.svg";
import btnBg3 from "@/assets/images/user/landing/btn-bg-3.svg";
import btnBgOn3 from "@/assets/images/user/landing/btn-bg-3-on.svg";
import footerLogo from "@/assets/images/user/landing/footer-logo.png";
import footerTopArrow from "@/assets/images/user/landing/footer-top-arrow.svg";
import games from "@/assets/images/user/landing/games.png";
import gnbLogo from "@/assets/images/user/landing/gnb-logo.svg";
import headphone from "@/assets/images/user/landing/headphone.svg";
import iconFacebook from "@/assets/images/user/landing/icon-facebook.svg";
import iconHome from "@/assets/images/user/landing/icon-home.svg";
import iconInstagram from "@/assets/images/user/landing/icon-instagram.svg";
import iconYoutube from "@/assets/images/user/landing/icon-youtube.svg";
import orgs from "@/assets/images/user/landing/orgs.png";
import orgsMobile from "@/assets/images/user/landing/orgs-mobile.png";
import stickerArrow from "@/assets/images/user/landing/sticker-arrow.svg";
import stickerEllipse from "@/assets/images/user/landing/sticker-ellipse.svg";
import stickerGxgLogo from "@/assets/images/user/landing/sticker-gxg-logo.svg";
import stickerHoverBg from "@/assets/images/user/landing/sticker-hover.png";
import stickerSoundtrackLogo from "@/assets/images/user/landing/sticker-soundtrack-logo.svg";
import subline from "@/assets/images/user/landing/subline.svg";
import title from "@/assets/images/user/landing/title.svg";
import { usePopupStore } from "@/store/common/usePopupStore";

import styles from "./styles.module.css";

/* ───── 사용자 이미지 ───── */
const LOCAL_IMG = {
    gnbLogo,
    background,
    headphone,
    title,
    subline,
    award,
    awardMobile,
    games,
    orgs,
    orgsMobile,
};

/* ───── Sticker SVG ───── */
const STICKER_SVG = {
    arrow: stickerArrow,
    gxgLogo: stickerGxgLogo,
    ellipse: stickerEllipse,
    soundtrackLogo: stickerSoundtrackLogo,
    hoverBg: stickerHoverBg,
};

/* ───── 자산 ───── */
const ASSET = {
    bgTop,
    bgTopTablet,
    bgTopMobile,
    bgBottom,
    bgBottomTablet,
    bgBottomMobile,
    arrowSchedule,
    btnBg1,
    btnBg2,
    btnBg3,
    btnBgOn1,
    btnBgOn2,
    btnBgOn3,
    btnArrowPurple,
    btnArrowWhite1: btnArrowWhite,
    btnArrowWhite2: btnArrowWhite,
    footerLogo,
    footerTopArrow,
    iconInstagram,
    iconFacebook,
    iconYoutube,
    iconHome,
};

/* ===========================================================================
   ROOT
   =========================================================================== */
export default function Landing() {
    return (
        <div className={styles.stageScaler}>
            <div className="stage">
                {/* ───── 상단 배경: PC/Tablet/Mobile 별도 이미지 ───── */}
                <picture>
                    <source media="(max-width: 767px)" srcSet={ASSET.bgTopMobile} />
                    <source media="(max-width: 1200px)" srcSet={ASSET.bgTopTablet} />
                    <img className="stage__bg stage__bg--top" src={ASSET.bgTop} alt="" />
                </picture>

                {/* ───── 하단 배경: PC/Tablet/Mobile 별도 이미지 ───── */}
                <picture>
                    <source media="(max-width: 767px)" srcSet={ASSET.bgBottomMobile} />
                    <source media="(max-width: 1200px)" srcSet={ASSET.bgBottomTablet} />
                    <img className="stage__bg stage__bg--bottom" src={ASSET.bgBottom} alt="" />
                </picture>

                <div className="stage__content">
                    <img className="stage__gnb" src={LOCAL_IMG.gnbLogo} alt="GNB 로고" />

                    <div className="stage__hero">
                        <div className="stage__hero-box">
                            <img className="stage__hero-bg hp-bg" src={LOCAL_IMG.background} alt="" />
                            <img className="stage__hero-img hp-float" src={LOCAL_IMG.headphone} alt="헤드폰 비주얼" />
                        </div>
                    </div>

                    <StickerBtn />

                    <div className="stage__event">
                        <img className="stage__title" src={LOCAL_IMG.title} alt="The 3rd GXG SOUND TRACK 타이틀" />
                        <img className="stage__subline" src={LOCAL_IMG.subline} alt="서브 라인 (일정)" />
                        <picture>
                            <source media="(max-width: 767px)" srcSet={LOCAL_IMG.awardMobile} />
                            <img className="stage__award" src={LOCAL_IMG.award} alt="상금 + 시상 4종" />
                        </picture>

                        <div className="stage__cont">
                            <div className="cont__heading">
                                <HeadingTxt
                                    tag="참가 대상"
                                    body="게임과 음악을 사랑하는 누구나"
                                    bodyWeight={500}
                                    className="max-md:flex-col max-md:content-start max-md:!items-start"
                                />
                            </div>
                            <div className="cont__heading cont__heading--apply">
                                <HeadingTxt
                                    tag="지원 방법"
                                    body="GXG 2026 홈페이지에서 참가 신청서 작성"
                                    bodyWeight={500}
                                />
                            </div>

                            <ScheduleSection />

                            <div className="cont__heading cont__heading--condition">
                                <HeadingTxt
                                    tag="참가 조건"
                                    body="아래 경연 주제로 제시된 게임을 모티브로 한 실연 가능한 창작곡"
                                    bodyWeight={500}
                                />
                            </div>

                            <GameLogosSection />
                            <SubmissionSection />
                            <NoticeSection />

                            <div className="cont__heading cont__heading--inquiry">
                                <HeadingTxt
                                    tag="문        의"
                                    body={
                                        <a
                                            href="mailto:info@gxg.world"
                                            style={{ color: "inherit", textDecoration: "none" }}
                                        >
                                            info@gxg.world
                                        </a>
                                    }
                                    bodyWeight={500}
                                />
                            </div>
                        </div>

                        <OrgsSection />
                        <ButtonsSection />
                    </div>
                </div>
            </div>
        </div>
    );
}

/* ===========================================================================
   상세 일정
   =========================================================================== */
function ScheduleSection() {
    return (
        <div className="schedule">
            <div className="schedule__header font-['GongGothicMedium']">
                <div className="schedule__header-left">
                    <div className="tag tag--purple">
                        <span className="tag__text">상세 일정</span>
                    </div>
                    <span className="schedule__header-body">아래 일정에 따라 순차 진행 및 공지</span>
                </div>
                <span className="schedule__caption">※ 주최측 사정에 따라 변동될 수 있습니다.</span>
            </div>

            <div className="schedule__box-container">
                <ScheduleBox tag="온라인 참가 접수" lines={["6.8.(월) - 7.19.(일) ", "홈페이지 내 참가 접수"]} />
                <ScheduleDivider />
                <ScheduleBox tag="예선 심사 및 발표" lines={["본선 진출자(팀) 대상 ", "8월 중 개별 연락"]} />
                <ScheduleDivider />
                <ScheduleBox tag="본선 경연 무대" lines={["9.11.(금) 저녁 ", "판교역 광장 메인 무대"]} />
                <ScheduleDivider />
                <ScheduleBox tag="갈라 콘서트" lines={["9.12.(토) 저녁 ", "판교역 광장 메인 무대"]} />
            </div>
        </div>
    );
}

function ScheduleBox({ tag, lines }: { tag: string; lines: string[] }) {
    return (
        <div className="schedule-box">
            <div className="schedule-box__tag font-['GongGothicMedium']">
                <span className="schedule-box__tag-text">{tag}</span>
            </div>
            <div className="schedule-box__body font-['GongGothicLight']">
                {lines.map((l, i) => (
                    <p key={i} className="schedule-box__body-line">
                        {l}
                    </p>
                ))}
            </div>
        </div>
    );
}

function ScheduleDivider() {
    return (
        <div className="schedule__divider">
            <div className="schedule__divider-line" />
        </div>
    );
}

/* ===========================================================================
   제출 자료
   =========================================================================== */
function SubmissionSection() {
    return (
        <div className="submission">
            <div className="submission__heading-row">
                <div className="tag tag--purple font-['GongGothicMedium']">
                    <span className="tag__text">제출사항</span>
                </div>
                <span className="submission__caption relative pl-[20px] font-['GongGothicLight'] before:absolute before:left-0 before:top-0 before:content-['※']">
                    모든 제출 자료는 본선 진출자(팀) 발표 공지 전까지 삭제되지 않도록 유의
                </span>
            </div>

            <div className="submission__box">
                <SubmissionItem
                    tag="음원"
                    leadMain="경연 주제로 제시된 게임을 모티브로 한 창작곡 1곡 AR 파일 제출"
                    leadSub="(파일 형태 : MP3)"
                    bullets={["곡 길이는 최소 2분 이상, 최대 5분 미만 ", "본선 진출 시 추가 MR 음원 요청 예정"]}
                />
                <SubmissionItem
                    tag="실연 영상"
                    leadMain="실제 연주 영상 URL 제출"
                    bullets={[
                        "본선 경연에 참여할 실제 팀으로 구성 ",
                        "노래와 연주 모습이 모두 보이도록 촬영 ",
                        "영상은 별도의 후반작업(보정, 믹싱 등) 없이 원본 상태로 제출",
                    ]}
                />
                <SubmissionItem
                    tag="스토리텔링"
                    leadMain="제출 곡과 게임 간 연관성에 대해 구체적인 스토리텔링 작성"
                    customBody={
                        <ul className="submission-item__bullets submission-item__bullets--wrap">
                            <li>
                                참고할 수 있는 레퍼런스 영상 및 이미지 첨부 가능 <br aria-hidden />
                                Ex. 모티브가 된 게임 영상, 인게임 그래픽, 캐릭터 및 아이템 이미지 등
                            </li>
                        </ul>
                    }
                />
            </div>
        </div>
    );
}

function SubmissionItem({
    tag,
    leadMain,
    leadSub,
    bullets,
    customBody,
}: {
    tag: string;
    leadMain: string;
    leadSub?: string;
    bullets?: string[];
    customBody?: React.ReactNode;
}) {
    return (
        <div className="submission-item">
            <div className="submission-item__tag font-['GongGothicMedium']">
                <span className="submission-item__tag-text">{tag}</span>
            </div>

            <div className="submission-item__lead font-['GongGothicMedium']">
                <span className="submission-item__lead-main">{leadMain}</span>
                {leadSub && <span className="submission-item__lead-sub">{leadSub}</span>}
            </div>

            {customBody ??
                (bullets && (
                    <ul className="submission-item__bullets font-['GongGothicLight']">
                        {bullets.map((b, i) => (
                            <li key={i}>{b}</li>
                        ))}
                    </ul>
                ))}
        </div>
    );
}

/* ===========================================================================
   유의사항
   =========================================================================== */
type NoticeItem = {
    no: string;
    body: React.ReactNode;
};

const NOTICES: NoticeItem[] = [
    {
        no: "①",
        body: "참가자(팀)가 직접 창작하고, 저작권의 모든 권리를 보유한 음악으로만 참가 신청할 수 있으며 제출한 곡으로 예산 심사 및 본선 경연이 진행됩니다.",
    },
    {
        no: "②",
        body: "지나친 욕설, 비난 및 비방, 폭력성 및 성적 묘사 등 사회적 물의를 일으킬 수 있는 요소(가사, 멜로디, 퍼포먼스 등)는 사용이 불가합니다.",
    },
    {
        no: "③",
        body: "이미 발표된 음악이라도 지정된 게임과의 연관성이 있다면 경연 참여가 가능합니다.",
    },
    { no: "④", body: "제출된 음원은 추가 편곡 및 수정이 불가합니다." },
    {
        no: "⑤",
        body: (
            <>
                <p className="notice__line">이전 회차 출품작 중 수상 이력이 없는 곡에 한해 재출품이 가능합니다.</p>
                <p className="notice__line notice__line--hint">
                    <span>※ GXG 2024-2025 게임음악 경연대회 기준 (The 1</span>
                    <span className="notice__sup">st</span>
                    <span>{` & 2`}</span>
                    <span className="notice__sup">nd</span>
                    <span>{` GXG SOUND TRACK)`}</span>
                </p>
            </>
        ),
    },
    {
        no: "⑥",
        body: (
            <>
                <p className="notice__line">
                    지원 횟수(곡 수)의 제한은 없으며 한 곡 당 한 개의 지정 게임만 선택하여 제출 가능합니다.{" "}
                    <br className="hidden lg:block" />
                    여러 곡을 제출할 경우 곡마다 별도의 참가 접수를 작성해 주시기 바랍니다.
                </p>
            </>
        ),
    },
    {
        no: "⑦",
        body: "참가 신청은 팀 당 대표 1명이 신청하며 개인 또는 팀 단위의 중복 참여(여러 곡 제출, 다수 그룹 참여) 가능합니다.",
    },
    {
        no: "⑧",
        body: (
            <>
                <p className="notice__line">
                    본선 진출자(팀)는 GXG 2026 행사 기간 중 진행되는 본선 경연 및 갈라 콘서트에 참여해야 하며 본선 경연
                    참여 인원은 참가 신청 시 제출한 팀원 구성과 동일해야 합니다.
                </p>
            </>
        ),
    },
    {
        no: "⑨",
        body: (
            <>
                <p className="notice__line">
                    해외여행 결격 사유가 없는 자만 신청할 수 있습니다. <br className="hidden lg:block" />
                    참가자의 허위 내용 작성 및 저작권, 초상권 관련 문제가 발생할 경우 자동으로 수상이 취소되며{" "}
                    <br className="hidden lg:block" />
                    이로 인해 발생하는 모든 민·형사상 책임은 참가자(팀) 본인에게 있습니다.
                </p>
            </>
        ),
    },
    {
        no: "⑩",
        body: (
            <>
                <p className="notice__line">
                    예선 결과 발표는 GXG 2026 공식 홈페이지를 통해 공개되며 본선 진출자(팀)에게는 8월 중 개별 연락이
                    진행됩니다.
                </p>
            </>
        ),
    },
    {
        no: "⑪",
        body: (
            <>
                <p className="notice__line">
                    주최 측 사정에 따라 경연 및 본 행사 일정, 장소 등 일부 내용이 변경될 수 있으므로 반드시{" "}
                    <br className="md:hidden lg:block" />
                    GXG 2026 공식 홈페이지를 통해 최신 정보를 확인하시기 바랍니다.
                </p>
            </>
        ),
    },
];

function NoticeSection() {
    return (
        <div className="notice">
            <div className="notice__heading-row">
                <div className="tag tag--purple">
                    <span className="tag__text font-['GongGothicMedium']">유의사항</span>
                </div>
            </div>

            {NOTICES.map((n, i) => (
                <div key={i} className="notice__item font-['GongGothicLight']">
                    <span className="notice__no">{n.no}</span>
                    <div className="notice__body">{n.body}</div>
                </div>
            ))}
        </div>
    );
}

/* ===========================================================================
   3 Buttons
   =========================================================================== */
function ButtonsSection() {
    const { setConfirmPop } = usePopupStore();

    const handleApplyClick = () => {
        const now = new Date();
        const openDate = new Date("2026-06-08T09:00:00");
        const closeDate = new Date("2026-07-20T00:00:00");

        if (now < openDate) {
            setConfirmPop(true, "6월 8일 오전 9시에 오픈됩니다!", 1);
        } else if (now >= closeDate) {
            setConfirmPop(true, "참가신청이 마감되었습니다.", 1);
        } else {
            window.open("https://forms.gle/ggvXuUxZsrN2vW5a6", "_blank");
        }
    };

    return (
        <div className="stage__buttons">
            <SoundTrackBtn
                bg={ASSET.btnBg1}
                hoverBg={ASSET.btnBgOn1}
                arrow={ASSET.btnArrowPurple}
                text="2025 경연 무대 보러가기"
                textColor="purple"
                onClick={() => window.open("https://www.youtube.com/@GXG_gameculture", "_blank")}
            />
            <SoundTrackBtn
                bg={ASSET.btnBg2}
                hoverBg={ASSET.btnBgOn2}
                arrow={ASSET.btnArrowWhite1}
                text="자주 묻는 질문"
                textColor="white"
                onClick={() => window.open("https://gxg.world/community/faq", "_blank")}
            />
            <SoundTrackBtn
                bg={ASSET.btnBg3}
                hoverBg={ASSET.btnBgOn3}
                arrow={ASSET.btnArrowWhite2}
                text="게임음악 경연대회 참가 신청"
                textColor="white"
                onClick={handleApplyClick}
            />
        </div>
    );
}

function SoundTrackBtn({
    bg,
    hoverBg,
    arrow,
    text,
    textColor,
    hoverTextColor,
    onClick,
}: {
    bg: string;
    hoverBg: string;
    arrow: string;
    text: string;
    textColor: "purple" | "white";
    hoverTextColor?: "purple" | "white";
    onClick?: () => void;
}) {
    const [isHovered, setIsHovered] = useState(false);
    const currentTextColor = isHovered && hoverTextColor ? hoverTextColor : textColor;

    return (
        <button
            className="soundtrack-btn"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <img
                className="soundtrack-btn__bg"
                src={bg}
                alt=""
                style={{ opacity: isHovered ? 0 : 1, transition: "opacity 0.2s" }}
            />
            <img
                className="soundtrack-btn__bg"
                src={hoverBg}
                alt=""
                style={{ opacity: isHovered ? 1 : 0, transition: "opacity 0.2s" }}
            />
            <span
                className={`soundtrack-btn__text soundtrack-btn__text--${currentTextColor} font-['GongGothicMedium']`}
            >
                {text}
            </span>
            <img className="soundtrack-btn__arrow" src={arrow} alt="" />
        </button>
    );
}

/* ===========================================================================
   응시 신청 Sticker — default(보라) / hover(라디얼+글로우)
   =========================================================================== */
function StickerBtn() {
    const { setConfirmPop } = usePopupStore();

    const handleClick = () => {
        const now = new Date();
        const openDate = new Date("2026-06-08T09:00:00");
        const closeDate = new Date("2026-07-20T00:00:00");

        if (now < openDate) {
            setConfirmPop(true, "6월 8일 오전 9시에 오픈됩니다!", 1);
        } else if (now >= closeDate) {
            setConfirmPop(true, "참가신청이 마감되었습니다.", 1);
        } else {
            window.open("https://forms.gle/ggvXuUxZsrN2vW5a6", "_blank");
        }
    };

    return (
        <button className="sticker" type="button" aria-label="게임음악 경연대회 참가 신청" onClick={handleClick}>
            <span className="sticker__ellipse">
                <img src={STICKER_SVG.ellipse} alt="" />
            </span>

            <span className="sticker__arrow-window">
                <span className="sticker__arrow-strip">
                    <img src={STICKER_SVG.arrow} alt="" />
                    <img src={STICKER_SVG.arrow} alt="" />
                </span>
            </span>

            <span className="sticker__content sticker__content--default">
                <img className="sticker__gxg-logo" src={STICKER_SVG.gxgLogo} alt="GXG-2026" />
                <p className="sticker__text">
                    게임음악 경연대회
                    <br />
                    참가 신청 바로가기
                </p>
            </span>

            {/* 호버 후: 버튼 전체를 덮는 PNG 한 장 (그라데이션/로고/화살표 대체) */}
            <img className="sticker__hover-png" src={STICKER_SVG.hoverBg} alt="" />
        </button>
    );
}

/* ===========================================================================
   공통: 보라 tag + 옆 body
   =========================================================================== */
function HeadingTxt({
    tag,
    body,
    bodyWeight = 500,
    bodySize = 28,
    className = "",
}: {
    tag: string;
    body: React.ReactNode;
    bodyWeight?: number;
    bodySize?: number;
    className?: string;
}) {
    return (
        <div className={`heading font-['GongGothicMedium'] ${className}`}>
            <div className="tag tag--purple">
                <span className="tag__text">{tag}</span>
            </div>
            <span
                className="heading__body"
                style={
                    {
                        fontWeight: bodyWeight,
                        "--body-fs": `${bodySize}px`,
                    } as React.CSSProperties
                }
            >
                {body}
            </span>
        </div>
    );
}

/* ===========================================================================
   경연 주제 — 게임 로고 그리드
   =========================================================================== */
function GameLogosSection() {
    return (
        <div className="games">
            <HeadingTxt tag="경연 주제" body="*가나다 순" bodyWeight={300} bodySize={20} />
            <img className="games__img" src={LOCAL_IMG.games} alt="참가대상 게임 로고" />
        </div>
    );
}

/* ===========================================================================
   주최 / 주관 / 후원 / 참여기업
   =========================================================================== */
function OrgsSection() {
    return (
        <picture>
            <source media="(max-width: 767px)" srcSet={LOCAL_IMG.orgsMobile} />
            <img className="stage__orgs" src={LOCAL_IMG.orgs} alt="주최 · 주관 · 후원 · 참여기업" />
        </picture>
    );
}
